var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 260 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sunGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ffd700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff9900",
    stopOpacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 240 45",
    to: "360 240 45",
    dur: "7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0;0;1",
    dur: "7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sunGradient)",
    d: "M259.67 44.566v-8h-25.175a23.072 23.072 0 0 0-3.86-9.307L248.44 9.453l-5.656-5.657-17.803 17.802a23.069 23.069 0 0 0-9.31-3.876V-7.434h-8v25.148a23.062 23.062 0 0 0-9.35 3.88l-17.78-17.78-5.657 5.657 17.78 17.78a23.082 23.082 0 0 0-3.865 9.315h-25.13v8h25.13a23.067 23.067 0 0 0 3.88 9.335L174.9 71.678l5.657 5.657 17.783-17.782a23.067 23.067 0 0 0 9.33 3.865v25.148h8V63.41a23.08 23.08 0 0 0 9.293-3.862l17.804 17.805 5.656-5.656-17.803-17.804a23.068 23.068 0 0 0 3.874-9.326h25.177zm-48.023-19.2c8.382 0 15.2 6.82 15.2 15.2 0 8.38-6.818 15.2-15.2 15.2-8.38 0-15.2-6.82-15.2-15.2 0-8.38 6.819-15.2 15.2-15.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "panels"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "2;0.4;0.3;1",
    dur: "7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "filter",
    values: "url(#glow);none;none;url(#glow)",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 236v6H43v-6h15v-22h6v22zM63.537 82l9.723 38h24.545l-9.773-38Zm20.981 82h24.603l-9.773-38H74.795Zm-6.193 0-9.723-38h-24.52l9.723 38zM26.632 82H2l9.772 38h24.582Zm40.435 38-9.723-38H32.825l9.723 38zm28.709 88h24.661l-9.773-38H86.053ZM55.34 170l9.723 38h24.52l-9.723-38Zm-17.45-44H13.315l9.772 38h24.525zm-13.259 44 9.772 38H58.87l-9.723-38zm154.036 20h17.055l6.686 26h-17.089ZM163 237v-16h-5v16h-11v5h27v-5zm-7.741-52-7.164-28h16.968l7.164 28zm-8.444-33-6.652-26h16.968l6.652 26zm26.691 38 6.652 26H163.19l-6.652-26zm-22.129 0 6.652 26h-16.834l-6.686-26zm-9.723-38h-16.917l-6.686-26h16.951zm8.444 33h-16.874l-7.201-28h16.911zm29.166-59 6.686 26h-17.006l-6.652-26zm-9.041 31h17.013l7.201 28h-17.049ZM240 238v4h-16v-4h6v-9h4v9zm-9.279-28 3.838 15h9.591l-3.838-15zm17.558 15H258l-3.858-15h-9.702zm-31.23-15 3.858 15h9.524l-3.838-15zm26.368-4h9.696l-4.115-16h-9.675zm-27.059-36h-9.596l4.115 16h9.575zm17.848 0 4.094 16h9.67l-4.115-16zm-12.731 20h-9.57l4.115 16h9.549zm17.813 16-4.094-16h-9.591l4.094 16zm-5.117-20-4.094-16h-9.591l4.094 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.bae1609f6b8d526311f529398dee23b8.svg";
export { ForwardRef as ReactComponent };